var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-player-bk"},[_c('video-player',{staticClass:"video-player",attrs:{"options":_vm.playerOptions}}),_c('img',{staticClass:"backtBtn",attrs:{"src":require("../assets/btn/teacher-back.gif"),"alt":""},on:{"click":_vm.goPath}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }